<template>
  <div class="profil-container" v-if="profile.length > 0">
    <h3 class="profil-title" v-if="formIsActive(profile[0])">{{ profile[0].text }}</h3>
    <p class="profil-subtitle" v-if="formIsActive(profile[1])">{{ profile[1].text }}</p>

    <div class="vendor-form-wrapper">
      <div v-for="(list, index) in profile.slice(2)" :key="index" class="vendor-form" v-if="formIsActive(list)">
        <p class="vendor-form-label">
          {{ list.text }}<span v-if="list.is_mandatory" class="text-ast">*</span>
        </p>

        <select v-model="$store.state.landingpage.badan_usaha_id" class="vendor-input" v-if="list.name == 'Profile-3'">
          <option v-for="(option, index) in bentukBadanUsaha" :key="index" :value="option.id">
            {{ option.desc }}
          </option>
        </select>

        <input class="vendor-input" type="text" v-model="vendorName"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          v-if="list.name == 'Profile-4'" />

        <input class="vendor-input-date" type="date" v-model="$store.state.landingpage.tglBerdiri"
          v-if="list.name == 'Profile-5'" max="9999-12-31"/>

        <div class="form-list-usaha" v-if="list.name == 'Profile-6'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column10">Kode</p>
              <p class="column40 mr10">Judul</p>
              <p class="column10">NIB</p>
              <p class="column10">SS IZIN</p>
              <p class="column20">Dokumen Lainnya</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedKbli" :key="index">
              <p class="column10">{{ list.kode }}</p>
              <p class="column40 col-nohover mr10">{{ list.desc }}</p>
              <p class="column10">
                <input type="checkbox" :value="list.nib && list.nib" v-model="addedKbli[index]['nib']" />
                {{ list.nib ? 'Ya' : 'Tidak' }}
              </p>
              <p class="column10">
                <input type="checkbox" :value="list.ss_izin && list.ss_izin" v-model="addedKbli[index]['ss_izin']" />
                {{ list.ss_izin ? 'Ya' : 'Tidak' }}
              </p>
              <p class="column20">
                <input type="checkbox" :value="list.dokumen_lainnya && list.dokumen_lainnya"
                  v-model="addedKbli[index]['dokumen_lainnya']" />
                {{ list.dokumen_lainnya ? 'Ya' : 'Tidak' }}
              </p>
            </div>
          </div>
          <div @click="openModalKbli()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <a class="text-btn-landing">Tambah</a>
          </div>
        </div>

        <div class="form-list-usaha" v-if="list.name == 'Profile-7'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column10 mr10">Jenis</p>
              <p class="column40">Bidang</p>
              <p class="column40">Sub Bidang</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedIujp" :key="index">
              <p class="column10 mr10">{{ list.jenis }}</p>
              <p class="column40">{{ list.bidang }}</p>
              <p class="column40">{{ list.sub_bidang }}</p>
            </div>
          </div>
          <div @click="openModalIujp()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <a class="text-btn-landing">Tambah</a>
          </div>
        </div>

        <div class="form-list-usaha" v-if="list.name == 'Profile-8'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column10">Kode</p>
              <p class="column40">Klasifikasi</p>
              <p class="column25">Sub Klasifikasi</p>
              <p class="column25">Kualifikasi</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedSbujk" :key="index">
              <p class="column10">{{ list.kode }}</p>
              <p class="column40">{{ list.klasifikasi }}</p>
              <p class="column25">{{ list.sub_klasifikasi }}</p>
              <p class="column25">{{ list.kualifikasi }}</p>
            </div>
          </div>
          <div @click="openModalSbujk()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div class="form-list-usaha" v-if="list.name == 'Profile-9'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column10">Jenis</p>
              <p class="column40">Bidang</p>
              <p class="column25">Sub Bidang</p>
              <p class="column25">Kualifikasi</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedIujptl" :key="index">
              <p class="column10">{{ list.jenis_usaha }}</p>
              <p class="column40">{{ list.bidang }}</p>
              <p class="column25">{{ list.sub_bidang }}</p>
              <p class="column25">{{ list.kualifikasi }}</p>
            </div>
          </div>
          <div @click="openModalIujptl()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div class="form-list-usaha" v-if="list.name == 'Profile-10'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column100">Bidang</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedInubbm" :key="index">
              <p class="column100">{{ list.desc }}</p>
            </div>
          </div>
          <div @click="openModalInubbm()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div class="form-list-usaha" v-if="list.name == 'Profile-11'">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column100">Bidang</p>
            </div>
            <div class="list-usaha-content" v-for="(list, index) in addedSiupal" :key="index">
              <p class="column100">{{ list.desc }}</p>
            </div>
          </div>
          <div @click="openModalSiupal()" class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <master-data-input-list :list="list" :step="'md_step_2'" :i="index" v-if="list.question_type !== 'default'" />

      </div>
    </div>

    <div v-for="(list, index) in checkedNames" :key="index">
      test: {{ list.name }} {{ list.desc }} {{ list.jenis }}
    </div>



    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goAlamat()" href="" class="btn-landing">
        Selanjutnya
      </div>
    </div>



    <Kbli v-if="$store.state.landingpage.addKbli" />
    <Iujp v-if="$store.state.landingpage.addIujp" />
    <Sbujk v-if="$store.state.landingpage.addSbujk" />
    <Iujptl v-if="$store.state.landingpage.addIujptl" />
    <Inubbm v-if="$store.state.landingpage.addInubbm" />
    <Siupal v-if="$store.state.landingpage.addSiupal" />
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'profilbu',
  components: {
    Kbli: () => import('@/components/modalLandingPage/AddKbli.vue'),
    Iujp: () => import('@/components/modalLandingPage/profileBuIujp.vue'),
    Sbujk: () => import('@/components/modalLandingPage/profileBuSbujk.vue'),
    Iujptl: () => import('@/components/modalLandingPage/profileBuIujptl.vue'),
    Inubbm: () => import('@/components/modalLandingPage/profileBuInubbm.vue'),
    Siupal: () => import('@/components/modalLandingPage/profileBuSiupal.vue'),
  },
  data() {
    return {
      selected: '',
      isModalVisible: false,
      checkedNames: [],
      bentukBadanUsaha: [],
      choosedBentukBadanUsaha: '',
    }
  },
  computed: {
    profile: function () {
      return this.$store.state.landingpage.md_step_2
    },
    vendorName: {
      get: function () {
        return this.$store.state.landingpage.vendorName
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'vendorName',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pemilikBank',
          value: newValue,
        })
      },
    },
    addedKbli: {
      get: function () {
        return this.$store.state.landingpage.addedKbli
      },
      set: function (newValue) {
        this.$store.dispatch('landingpage')
      },
    },
    addedIujp: function () {
      return this.$store.state.landingpage.addedIujp
    },
    addedSbujk: function () {
      return this.$store.state.landingpage.addedSbujk
    },
    addedIujptl: function () {
      return this.$store.state.landingpage.addedIujptl
    },
    addedInubbm: function () {
      return this.$store.state.landingpage.addedInubbm
    },
    addedSiupal: function () {
      return this.$store.state.landingpage.addedSiupal
    },
  },
  created() {
    this.getBentukBadanUsaha()
  },
  methods: {
    checkForm() {
      const {
        badan_usaha_id,
        tglBerdiri,
        vendorName,
      } = this.$store.state.landingpage

      let arr = []

      let profile = this.profile.slice(2)
      for (let i in profile) {
        if (profile[i].name == 'Profile-3' && profile[i].is_mandatory && profile[i].is_active) { arr.push([badan_usaha_id, profile[i].text]) }
        else if (profile[i].name == 'Profile-4' && profile[i].is_mandatory && profile[i].is_active) { arr.push([vendorName, profile[i].text]) }
        else if (profile[i].name == 'Profile-5' && profile[i].is_mandatory && profile[i].is_active) { arr.push([tglBerdiri, profile[i].text]) }
        else if (profile[i].name == 'Profile-6' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedKbli.length > 0, profile[i].text]) }
        else if (profile[i].name == 'Profile-7' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedIujp.length > 0, profile[i].text]) }
        else if (profile[i].name == 'Profile-8' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedSbujk.length > 0, profile[i].text]) }
        else if (profile[i].name == 'Profile-9' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedIujptl.length > 0, profile[i].text]) }
        else if (profile[i].name == 'Profile-10' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedInubbm.length > 0, profile[i].text]) }
        else if (profile[i].name == 'Profile-11' && profile[i].is_mandatory && profile[i].is_active) { arr.push([this.addedSiupal.length > 0, profile[i].text]) }
        else if (!profile[i].is_default && profile[i].is_active && profile[i].is_mandatory) {
          arr.push([profile[i].value, profile[i].text])
        }

      }

      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'instruction')
    },
    goAlamat() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'alamat_step',
          value: true,
        })
      }
    },
    async getBentukBadanUsaha() {
      const {
        bidang_usaha_id,
        type_pendaftaran_id,
      } = this.$store.state.landingpage

      const url = `${api}/api/v1/badan-usaha?page=1&limit=100&bidang_usaha_id=${bidang_usaha_id}&type_pendaftaran_id=${type_pendaftaran_id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.bentukBadanUsaha = data && data.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    openModalKbli() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addKbli',
        status: true,
      })
    },
    openModalIujp() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addIujp',
        status: true,
      })
    },
    openModalSbujk() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addSbujk',
        status: true,
      })
    },
    openModalIujptl() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addIujptl',
        status: true,
      })
    },
    openModalInubbm() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addInubbm',
        status: true,
      })
    },
    openModalSiupal() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addSiupal',
        status: true,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
